import {BONUS_VIEWPORT_SAFE_ZONE, GameObjectsTags} from '../ClickerGame.constants';
import {ClickerGCSEngine} from '../ClickerGame.types';
import {Rectangle} from 'pixi.js';

import {isRectIntersectsRect} from 'aabb-collisions-detector';

import {IGameObject, IGameScript} from '@specials/gcs-engine';

import {PixiViewComponent} from '@/gcs/PixiViewComponent';

export class BonusesObserverScript implements IGameScript {
  private bonusLifeZone: Rectangle;

  constructor(private readonly gcsEngine: ClickerGCSEngine) {}

  public create(): void {
    const {width, height} = this.gcsEngine.renderer.renderer.getFrameDimensions();

    // зона жизни объекта должна быть немного больше чем размеры сцены,
    // чтобы объект не удалился сразу же после появления
    this.bonusLifeZone = new Rectangle(
      -BONUS_VIEWPORT_SAFE_ZONE,
      -BONUS_VIEWPORT_SAFE_ZONE,
      // при включении обновления поворота объекта AABB коллизии по width, height работают не корректно
      // из-за увеличения ширины и высоты объекта, поэтому умножаем на 15 чтобы увеличить вьюпорт
      width + BONUS_VIEWPORT_SAFE_ZONE * 15,
      height + BONUS_VIEWPORT_SAFE_ZONE * 15,
    );
  }

  public update(): void {
    this.gcsEngine.world
      .getGameObjectListByTag(GameObjectsTags.Bonus)
      .forEach((go) => this.checkBonusInGameVisibleStage(go));
  }

  private checkBonusInGameVisibleStage(go: IGameObject): void {
    const viewComponent = go.getComponentByTag<PixiViewComponent>('ViewComponent');

    if (!viewComponent) return;

    if (!isRectIntersectsRect(viewComponent.bounds, this.bonusLifeZone)) {
      go.setAsDestroyed();
    }
  }
}
